import { useContext } from 'react'
import { DefaultTheme, ThemeContext } from 'styled-components'

export const useTheme = (): DefaultTheme => {
  const theme = useContext(ThemeContext)
  if (!theme) throw new Error('Cannot use theme outside ThemeProvider')
  return theme
}
